<template>
  <div
    v-if="modalState === 'navigate'"
    class="eventmap-page__navigation gap-y-4"
  >
    <template v-if="mode !== 'kiosk'">
      <div class="eventmap-page__navigation-from-icon">
        <i class="far fa-circle"></i>
      </div>
      <div class="eventmap-page__navigation-from-holder">
        <input
          type="text"
          class="frontend-text-input"
          placeholder="Start"
          :value="routeStart ? `${routeStart.name || ''} ${routeStart.number || ''}`.trim() : ''"
          @focus="() => modalState = 'set-start'"
        />
      </div>
      <div class="eventmap-page__navigation-reverse">
        <button
          @click.stop="reverseNavigation"
          type="button"
          class="eventmap-page__navigation-reverse-button"
        >
          <i class="fas fa-arrow-up-arrow-down"></i>
        </button>
      </div>
    </template>
    <template v-else>
      <div class="eventmap-page__navigation-from-icon eventmap-page__current-location-icon">
        <i class="fas fa-map-marker-alt"></i>
      </div>
      <div
        class="col-span-2"
      >
        Your current location: {{ routeStart?.name }}
      </div>
    </template>

    <div class="eventmap-page__navigation-to-icon">
      <i class="far fa-location-dot"></i>
    </div>

    <div class="eventmap-page__navigation-to-holder">
      <input
        type="text"
        class="frontend-text-input"
        placeholder="Destination"
        :value="routeEnd ? `${routeEnd.name || ''} ${routeEnd.number || ''}`.trim() : ''"
        @focus="() => modalState = 'set-destination'"
      />
    </div>
    <div class="eventmap-page__navigation-buttons">
      <button type="button" class="button button--secondary" @click="closeNavigation">
        <i class="far fa-arrow-left"></i> Back
      </button>
      <button
        type="button"
        class="button button--primary"
        :disabled="!routeEnd || !routeStart"
        @click="() => modalState = 'route'"
      >
        <i class="far fa-route"></i> Directions
      </button>
    </div>
  </div>
</template>

<script setup>
import { defineModel } from 'vue';

const props = defineProps({
  mode: {
    type: String,
    default: 'platform',
  },
});

const emit = defineEmits(['onLocationSelected']);

const modalState = defineModel('modalState', { type: String, default: 'normal' });
const routeStart = defineModel('routeStart', { type: Object, default: null });
const routeEnd = defineModel('routeEnd', { type: Object, default: null });
const selectedLocation = defineModel('selectedLocation', { type: Object, default: null });
const activePath = defineModel('activePath', { type: Object, default: null });

const closeNavigation = () => {
  // Clear route start if not in kiosk mode
  if (props.mode !== 'kiosk') {
    routeStart.value = null;
  }

  // Clear route end and active path
  routeEnd.value = null;
  activePath.value = null;

  // Emit location selection event if a location is selected
  if (selectedLocation.value?.id) {
    emit('onLocationSelected', { ...selectedLocation.value });
  } else {
    // Reset modal state to default
    modalState.value = 'normal';
  }
};

const reverseNavigation = () => {
  if (routeStart.value || routeEnd.value) {
    // Swap routeStart and routeEnd values
    [routeStart.value, routeEnd.value] = [routeEnd.value, routeStart.value];
  } else {
    // eslint-disable-next-line no-console
    console.log('Cannot reverse navigation: Both start and end locations are empty.');
  }
};
</script>
